import {type ReactNode, useReducer, type JSX} from 'react'
import {DEFAULT_FLEET_SCORE_OVER_TIME_STATE} from './types/default-fleet-score-over-time-state'
import {fleetScoreOverTimeReducer} from './state/reducer'
import {FleetScoreOverTimeContext} from './fleet-score-over-time-context'

type FleetScoreOverTimeProviderProps = {
    children: ReactNode
}

export function FleetScoreOverTimeProvider({
    children,
}: FleetScoreOverTimeProviderProps): JSX.Element {
    const [state, dispatch] = useReducer(
        fleetScoreOverTimeReducer,
        DEFAULT_FLEET_SCORE_OVER_TIME_STATE,
    )

    return (
        <FleetScoreOverTimeContext value={{state, dispatch}}>{children}</FleetScoreOverTimeContext>
    )
}
